import React from "react";
import { Route, Routes } from "react-router-dom";
import RmPartnerReport from "./RmPartnerReport";
import IndividualReportView from "./IndividualReportView";
import ZerosingReport from "./ZerosingReport";
var ReportsRouting = function () {
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, path: "/", element: React.createElement(RmPartnerReport, null) }),
        React.createElement(Route, { path: "/:categoryName/:categoryId", element: React.createElement(IndividualReportView, null) }),
        React.createElement(Route, { path: "/zerosing-report/:categoryName/:categoryId", element: React.createElement(ZerosingReport, null) })));
};
export default ReportsRouting;
